export default __webpack_public_path__ + "static/test-image-1-ff14062bb1690aae9bd70b47f50f4955.jpg";